import type { AppRouteRecordRaw } from "shared/types";
import { LAYOUTS, MODULE_SETTINGS, TEACHER_ROLES } from "shared/constants";
import { STUDENT_MEETING_ROUTE_NAMES } from "meetings/student-meeting/routes/routeNames";

/**
 * Meeting route fragment for /my-students/meetings
 * Import and spread into myStudentsRoutes.js children array.
 */
export const myStudentsStudentMeetingFragment: AppRouteRecordRaw[] = [
  {
    path: "meetings",
    name: STUDENT_MEETING_ROUTE_NAMES.MY_STUDENTS,
    component: () =>
      import("meetings/student-meeting/pages/teacher/MyStudentsStudentMeetingPage.vue"),
    meta: {
      title: "Leerlingbespreking",
      isMenuItem: true,
      menuSection: "main",
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      roleRequired: TEACHER_ROLES,
      hideTitle: true,
    },
  },
];
